import React from "react";
import "../styles/UpskillingCourses.css";

const UpskillingCourses = () => {
  return (
    <div className="upskilling-courses-page">
      <h1>🚀 Upskilling Resources</h1>
      <p>Learn new skills and stay ahead in your career.</p>

      <section className="courses-list">
        <h2>🔹 Free & Paid Courses</h2>
        <ul>
          <li>🎯 <strong>Full-Stack Web Development</strong> - FreeCodeCamp (<a href="https://www.freecodecamp.org/" target="_blank" rel="noopener noreferrer">Enroll Now</a>)</li>
          <li>🎯 <strong>Machine Learning & AI</strong> - Coursera (<a href="https://www.coursera.org/" target="_blank" rel="noopener noreferrer">Enroll Now</a>)</li>
          <li>🎯 <strong>Data Structures & Algorithms</strong> - Udemy (<a href="https://www.udemy.com/" target="_blank" rel="noopener noreferrer">Enroll Now</a>)</li>
        </ul>
      </section>
    </div>
  );
};

export default UpskillingCourses;
